import React, { useState, useContext } from 'react';
import styles from './CountrySelector.module.scss';
import countries from './allCountries';

import { LanguageContext } from '../../context/LanguageContext';

// Import des traductions 
import translations from '../../utils/translations/CountrySelectorTranslations';

const CountrySelector = ({ value, onChange }) => {

  // Utilisation du contexte de langue global et accès simplifié aux traductions
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.fr;

  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const normalize = (str) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const filteredCountries = countries.filter((country) =>
    normalize(country.label).startsWith(query.toLowerCase())
  );

  const handleSelect = (countryCode) => {
    onChange(countryCode);
    const country = countries.find(c => c.code === countryCode);
    setQuery(country?.label || '');
    setIsOpen(false);
  };

  return (
    <div className={styles.selectorContainer}>
      <input
        type="text"
        autoComplete="new-password"
        id="country-autocomplete"
        name="country-autocomplete"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setIsOpen(true);
        }}
        onFocus={() => setIsOpen(true)}
        placeholder="Choisissez un pays"
        className={styles.input}
      />
      {isOpen && query.length > 0 && filteredCountries.length > 0 && (
        <ul className={styles.dropdown}>
          {filteredCountries.map((country) => (
            <li
              key={country.code}
              onClick={() => handleSelect(country.code)}
              className={styles.option}
            >
              {country.flag} {country.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CountrySelector;
